// Fallo de registrar el equipo y abrir su candado: el mensaje, el reintento cuando sirve y la salida
// cuando reintentar no lo arregla.
import { Button } from '@/kit';
import {
    deviceErrorBlamesImei,
    deviceErrorEnrollmentFailed,
    deviceErrorLocksImei,
    deviceErrorMessage,
    deviceErrorNeedsProduct,
    deviceErrorRejectedByLock,
    deviceErrorRetryHelps,
} from '../../deviceErrors';
import { useWizardExit } from '../WizardExit';
import { InlineQueryError } from '../QueryErrorNotice';

export function DeviceRegisterError({
    error,
    onRetry,
    retrying,
    onBackToProduct,
}: {
    error: unknown;
    onRetry: () => void;
    retrying: boolean;
    onBackToProduct: () => void;
}) {
    const exit = useWizardExit();
    const needsProduct = deviceErrorNeedsProduct(error);
    const rejectedByLock = deviceErrorRejectedByLock(error);
    const imeiStuck = deviceErrorLocksImei(error) || deviceErrorBlamesImei(error);
    const retryable =
        !needsProduct &&
        !imeiStuck &&
        !deviceErrorEnrollmentFailed(error) &&
        deviceErrorRetryHelps(error);

    return (
        <>
            <InlineQueryError
                className="text-[12px]"
                message={deviceErrorMessage(error)}
                onRetry={retryable ? onRetry : undefined}
                retrying={retrying}
            />
            {/* El IMEI ya no se puede mover: reintentar no arregla nada. */}
            {imeiStuck && (
                <p className="text-[11.5px] leading-relaxed text-muted-foreground">
                    Si el IMEI registrado está equivocado, la única salida es cancelar la venta y
                    volver a levantarla.
                </p>
            )}
            {/* El proveedor rechazó el equipo: si no se resuelve, la salida es cancelar la venta. */}
            {rejectedByLock && exit?.canCancelSale && exit.openCancelDialog && (
                <div className="flex flex-col gap-1.5">
                    <p className="text-[11.5px] leading-relaxed text-muted-foreground">
                        Si soporte no puede habilitarlo, cancela la venta; lo cobrado queda como
                        reembolso pendiente.
                    </p>
                    <div className="flex justify-start">
                        <Button variant="outline" size="sm" onClick={exit.openCancelDialog}>
                            Cancelar venta
                        </Button>
                    </div>
                </div>
            )}
            {needsProduct && (
                <div className="flex justify-start">
                    <Button variant="outline" size="sm" onClick={onBackToProduct}>
                        Volver a elegir el equipo
                    </Button>
                </div>
            )}
        </>
    );
}
